import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const EducationExperience = () => {
  return (
    <div>
      <Navbar />
      <div className="text-white max-w-[800px] mt-[-96px] mb-[20px] w-full h-full mx-auto pl-2 font-main">
        <div className="pt-[150px]">
            <div className="pt-10 ml-[100px] mr-[100px]">
                <h1 className="text-[#00df9a] uppercase text-3xl text-center border-b ">
                    Education
                </h1>
            </div>          
        <div className="pt-4">
            <h2 className="text-xl text-[#00df9a]">Worcester Polytechnic Institute (WPI), USA</h2>
            <p className="italic  text-[#00df9a]">Master’s in Computer Science (Minor: AI) | Jan 2024 – Dec 2025 | GPA: 4.0/4.0</p>
            <ul className="list-disc pl-6 pt-2 pb-3">
              <li>Focused on Machine Learning, Deep Learning, and Data Science.</li>
              <li>Research on AI-driven healthcare.</li>
              <li>Relevant coursework: Machine Learning, Information Retrieval, Generative AI, Machine Learning Development and Operations, Database Management System, Operating Systems.</li>
            </ul>
          </div>

          <div className="pt-4">
            <h2 className="text-xl text-[#00df9a]">College Of Engineering, Anna University, India</h2>
            <p className="italic  text-[#00df9a]">Bachelor of Technology in Information Technology | 2017 – 2021 | GPA: 8.01/10</p>
            <ul className="list-disc pl-6 pt-2 pb-3">
              <li>Graduated with strong foundation in software development and databases.</li>
              <li>Projects in Web Development.</li>
              <li>Coursework: Database Systems, Data Structures, Operating Systems, Computer Networks.</li>
            </ul>
          </div>
        </div>

        <div className="pt-10 ml-[100px] mr-[100px]">
          <h1 className="text-[#00df9a] uppercase text-3xl text-center border-b ">
            Experience
          </h1>
        </div>

        <div className="pt-6">
          <h2 className="text-xl text-[#00df9a]">Software Engineer | Gain Credits, India</h2>
          <p className="italic text-[#00df9a]">Jun 2021 – Dec 2023</p>
          <ul className="list-disc pl-6 pt-2 pb-3">
            <li>Developed and maintained scalable backend services using Python, Django, and REST APIs.</li>
            <li>Worked with MySQL and MongoDB to design and optimize databases.</li>
            <li>Collaborated in an Agile team, delivering features on time with high quality.</li>
            <li>Improved system performance by resolving bugs and optimizing queries.</li>
          </ul>
        </div>
        <div className="pt-6">
          <h2 className="text-xl text-[#00df9a]">Data Science Intern | Datycs, USA</h2>
          <p className="italic text-[#00df9a]">May 2025 – Aug 2025</p>
          <ul className="list-disc pl-6 pt-2 pb-3">
            <li>Conducted research on AI-based models for Named Entity Recognition to extract medical entities.</li>
            <li>Analyzed datasets and provided actionable insights.</li>
            <li>Processed large datasets using Google Colab and Python libraries (Pandas, NumPy, Scikit-learn).</li>
          </ul>
        </div>
        <div className="pt-6">
          <h2 className="text-xl text-[#00df9a]">Graduate Researcher| WPI, USA</h2>
          <p className="italic text-[#00df9a]">May 2024 – Jul 2025</p>
          <ul className="list-disc pl-6 pt-2 pb-3">
            <li>Conducting research on AI-based skin cancer classification models.</li>
            <li>Implemented Transformer models for medical image datasets.</li>
            <li>Explored and implemented Retrieval-Augmented Generation (RAG) applications using corpus books and large language models to build a customized NLP-centric chatbot.</li>
          </ul>
        </div>

        <div className="pt-6">
          <h2 className="text-xl text-[#00df9a]">Graduate Learning Assistant | WPI, USA</h2>
          <p className="italic text-[#00df9a]">Aug 2024 – Jul 2025</p>
          <ul className="list-disc pl-6 pt-2 pb-3">
            <li>Assisted Professor in mentoring students in AI and database courses.</li>
            <li>Graded assignments, held office hours, and guided students on projects and assignments.</li>
          </ul>
        </div>


        <div className="mt-[10px] mb-[30px]">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default EducationExperience;
